<template>
  <div>
    <Widget>
      <WidgetBody>
        <form
          id="create-campaign"
          name="create-campaign"
          @submit.prevent="createNewCampaign"
          ref="form"
          class="grid grid-cols-1 gap-2 w-2/5"
        >
          <YInput v-model="campaignName" label="Campaign Name" />

          <Superselect
            title="Show Front-end"
            v-model="showFrontend"
            :multiple="false"
            placeholder="Select"
            :options="['All In Affiliates', 'yTrack']"
          ></Superselect>

          <Superselect
            title="Payout Type"
            v-model="payoutType"
            :multiple="false"
            placeholder="Select"
            :options="introspectionType"
          ></Superselect>

          <div class="mt-4">
            <YButton color="blue" type="submit" :isLoading="isCreating"
              >Create Campaign</YButton
            >
          </div>
        </form>
      </WidgetBody>
    </Widget>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import CREATE_CAMPAIGN_MUTATION from '@/graphql/Campaign/CreateCampaignMutation.gql'

export default {
  components: {},
  apollo: {
    introspectionType: {
      query: gql`
        query IntrospectionType($name: String!) {
          introspectionType: __type(name: $name) {
            name
            enumValues {
              name
            }
          }
        }
      `,
      variables: {
        name: 'CampaignPayoutTypeEnum'
      },
      update(data) {
        return data.introspectionType.enumValues.map(e => e.name.toUpperCase())
      }
    }
  },

  data() {
    return {
      isCreating: false,
      campaignName: null,
      showFrontend: null,
      payoutType: 'CPA',
      setPayoutTypes: {
        cpa: {
          approvalRequiredTypes: [],
          baselineMinimumView: true
        },
        cpl: {
          approvalRequiredTypes: ['quarantined'],
          baselineMinimumView: false
        },
        cpi: {
          approvalRequiredTypes: undefined,
          baselineMinimumView: false
        },
        cps: {
          approvalRequiredTypes: undefined,
          baselineMinimumView: false
        },
        cpc: {
          approvalRequiredTypes: undefined,
          baselineMinimumView: false
        },
        revshare: {
          approvalRequiredTypes: undefined,
          baselineMinimumView: false
        }
      }
    }
  },
  methods: {
    createNewCampaign() {
      this.isCreating = true
      const selectedPayoutType = this.setPayoutTypes[
        this.payoutType.toLowerCase()
      ]

      this.$apollo
        .mutate({
          mutation: CREATE_CAMPAIGN_MUTATION,
          variables: {
            input: {
              name: this.campaignName,
              showFrontend: this.showFrontend,
              payoutType: this.payoutType,
              approvalRequiredTypes:
                selectedPayoutType?.approvalRequiredTypes ?? undefined
            }
          }
        })
        .then(result => {
          this.isCreating = false
          this.$router.push({
            name: 'Campaign',
            params: { id: result.data.createCampaign.id }
          })
        })
        .catch(error => {
          console.log('error')
          this.$toastr.e(error, 'Oops!')
          this.isCreating = false
        })
    }
  }
}
</script>
